module.exports = __webpack_public_path__ + "static/img/grade-button.db2502b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade-button.png
// module id = WRqx
// module chunks = 0